import React, { useState, useEffect } from "react";
import { Theme, useTheme } from '@mui/material/styles'
import { makeStyles } from "@mui/styles";
import {
  Button,
  Chip,
  FormControl,
  Grid,
  Input,
  InputLabel,
  MenuItem,
  Paper,
  Select,
} from "@mui/material";
import { getSalesOfficesAndRoutes } from "../../utils/GetPlanning";
import requestMissingContexts, { determineConfig, displayConfig } from "../../utils/GetContext";
import { useLocalStorage } from "../../componentUtils/LocalStorage";

interface Inputs {
  onSelectionChange: any;
}

interface HeaderState {
  isLoaded: boolean,
  allSalesOffices: any,
  allRoutes: any,
  allSubTradeChannels: any,
  filteredRoutes: string[],
  salesOffices: string[],
  routes: string[],
  subtradeChannels: string[],
}

interface SalesOffice {
  salesOffice: string,
  name: string,
}

export const tableHeightReducePx = 75;
export default function Header(props: Inputs) {
  const [defaultSalesOffice,] = useLocalStorage("SETTINGS.defaultSalesOffice", '');
  const theme: Theme = useTheme();
  const useStyles = makeStyles((theme: Theme) => ({
    cont: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
    },
    grid: {
      marginLeft: theme.spacing(1),
    },
    save: {
      textAlign: "center",
      justify: "center",
    },
    chips: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    chip: {
      margin: 2,
    },
    formControl: {
      minWidth: 200,
      margin: theme.spacing(1),
    },
  }));

  const classes = useStyles();
  const [state, setState] = useState<HeaderState>({
    isLoaded: false,
    allSalesOffices: [],
    allRoutes: [],
    allSubTradeChannels: [],
    filteredRoutes: [],
    salesOffices: [],
    routes: [],
    subtradeChannels: [],
  });

  const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
  useEffect(() => {
    if (state.isLoaded) return;

    getSalesOfficesAndRoutes(salesOrg.toString()).then(
      (v:any) => {
        const r_so:any[] = v.salesOffices;
        const r_rt:any[] = v.routes;
        if (r_so && r_rt) {
          requestMissingContexts(["FSVSUBTRADECHANNEL","SALESOFFICES"]).then((ctx) => {
            const contexts:any = ctx;
            var salesOffices: Array<SalesOffice> = [];
            for (var i=0; i<r_so.length; i++) {
              const so = r_so[i].salesOffice;
              const desc = so + ": " + determineConfig(
                contexts,
                "SALESOFFICES",
                so || ""
              );
              const salesOffice:SalesOffice = {salesOffice: so, name: desc};
              salesOffices.push(salesOffice);
            }
            const stc = displayConfig(contexts, "FSVSUBTRADECHANNEL");
            let rts:any[] = [] 
            if(defaultSalesOffice !== ''){
              rts = rts.concat(r_rt.filter((elem: { salesOffice: any; }) => elem.salesOffice === defaultSalesOffice)).map((rts:any)=>rts.route);
            }
            setState({
              ...state,
              isLoaded: true,
              allSalesOffices: salesOffices,
              allRoutes: r_rt,
              allSubTradeChannels: stc,
              salesOffices:defaultSalesOffice?[defaultSalesOffice]:[],
              filteredRoutes: rts,
            });
          });
        }
      }
    )
  }, [state]);

  const handleSOChange = (event: any) => {
    let value = event.target.value;
    //console.log(value)
  
    if (value) {
      // get all combined routes
      var filteredRoutes = new Map<string, boolean>();
      for(var i:number = 0; i<value.length; i++) {
        const rts = state.allRoutes.filter((elem: { salesOffice: any; }) => elem.salesOffice === value[i]);
        for(var j:number = 0; j<rts.length; j++) {
          filteredRoutes.set(rts[j].route, true);
        }
      }
      const ftr = Array.from(filteredRoutes.keys());
     // tempdefaultSalesOffice.push(value)
     //console.log(value)
      setState({...state, salesOffices: value, filteredRoutes: ftr});
    }
  }
  const handleRouteChange = (event: any) => {
    let value = event.target.value;
    if (value) {
      setState({...state, routes: value});
    }
  }

  const handleSTCChange = (event: any) => {
    let value = event.target.value;
    if (value) {
      setState({...state, subtradeChannels: value});
    }
  }

  const getStyles = (key: string, arr: string[]) => {
    return {
      fontWeight:
        arr.indexOf(key) === -1
          ? theme.typography.fontWeightRegular
          : theme.typography.fontWeightMedium,
    };
  }


  return (
    <Paper className={classes.cont}>
      <Grid className={classes.grid} container spacing={3}>
        <Grid item lg={4} md={4} xl={4} xs={4}>
        <FormControl className={classes.formControl} fullWidth>
        <InputLabel id="select-multiple-so-label">Sales Offices</InputLabel>
        <Select
          multiple
          fullWidth
          value={state.salesOffices || ""}
          onChange={handleSOChange}
          input={<Input id="select-multiple-so" />}
          renderValue={(selected: any) => (
            <div className={classes.chips}>
              {selected.map((value: any) => (
                <Chip key={value} label={value} className={classes.chip} />
              ))}
              
            </div>
          )}
        >
          {state.allSalesOffices.map((option: any) => (
            <MenuItem key={option.salesOffice} value={option.salesOffice} style={getStyles(option.salesOffice, state.allSalesOffices)}>
              {option.name}
            </MenuItem>
          ))}
        </Select>
        </FormControl>
        </Grid>

        <Grid item lg={3} md={3} xl={3} xs={3}>
        <FormControl className={classes.formControl} fullWidth>
        <InputLabel id="select-multiple-route-label">Routes</InputLabel>
        <Select
          multiple
          fullWidth
          value={state.routes || ""}
          onChange={handleRouteChange}
          input={<Input id="select-multiple-route" />}
          renderValue={(selected: any) => (
            <div className={classes.chips}>
              {selected.map((value: any) => (
                <Chip key={value} label={value} className={classes.chip} />
              ))}
            </div>
          )}
        >
          {state.filteredRoutes.map((route, index: number) => (
            <MenuItem key={index} value={route} style={getStyles(route, state.filteredRoutes)}>
              {route}
            </MenuItem>
          ))}
        </Select>
        </FormControl>
        </Grid>

        <Grid item lg={4} md={4} xl={4} xs={4}>
        <FormControl className={classes.formControl} fullWidth>
        <InputLabel id="select-multiple-stc-label">Sub Trade Channels</InputLabel>
        <Select
          multiple
          fullWidth
          value={state.subtradeChannels || ""}
          onChange={handleSTCChange}
          input={<Input id="select-multiple-stc" />}
          renderValue={(selected: any) => (
            <div className={classes.chips}>
              {selected.map((value: any) => (
                <Chip key={value} label={value} className={classes.chip} />
              ))}
            </div>
          )}
        >
          {state.allSubTradeChannels.map((option: any) => (
            <MenuItem key={option.code} value={option.code} style={getStyles(option.code, state.allSubTradeChannels)}>
              {option.text}
            </MenuItem>
          ))}
        </Select>
        </FormControl>
        </Grid>
        <Grid item lg={1} md={1} xl={1} xs={1}>
          <Button onClick={() => props.onSelectionChange(state.salesOffices, state.routes, state.subtradeChannels)}>Load Report Data</Button>
        </Grid>
      </Grid>
    </Paper>
  );
}
